import { SERVICE_COLLECTION } from '../constants';
import { TYPE_COLLECTION } from './input-types';

// TODO: this should be renamed RATE_SHOPPER
export const id = SERVICE_COLLECTION;
export const apiKey = 'ServiceCollectionGuid';
export const type = TYPE_COLLECTION;

export const rateShopper = {
  id,
  apiKey,
  type,
};
